import { render, staticRenderFns } from "./AddTreatmentModal.vue?vue&type=template&id=b58d7300&"
import script from "./AddTreatmentModal.vue?vue&type=script&lang=js&"
export * from "./AddTreatmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports